import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	planningResourcesHeading: {
		id: 'fastshift.resources-page.planning-resources-heading',
		defaultMessage: 'Planning resources',
		description: 'Heading for planning resources section',
	},
	card1Heading: {
		id: 'fastshift.resources-page.card1.heading',
		defaultMessage: 'Portfolio insights',
		description: 'Heading for the assessments card 1',
	},
	card1Description: {
		id: 'fastshift.resources-page.tooling-card.description',
		defaultMessage: 'Understand how you’ll assess your cloud readiness with Portfolio insights.',
		description: 'Description for the assessments card 1',
	},
	card2Heading: {
		id: 'fastshift.resources-page.card2.heading',
		defaultMessage: 'Detect and connect to your portfolio',
		description: 'Heading for the assessments card 2',
	},
	card2Description: {
		id: 'fastshift.resources-page.card2.description',
		defaultMessage: 'Use Portfolio insights to discover and connect to your instances.',
		description: 'Description for the assessments card 2',
	},
	card3Heading: {
		id: 'fastshift.resources-page.card3.heading',
		defaultMessage: 'Assess Jira cloud readiness',
		description: 'Heading for the assessments card 3',
	},
	card3Description: {
		id: 'fastshift.resources-page.card3.description',
		defaultMessage: 'How to assess cloud readiness by collecting data from your Jira instance.',
		description: 'Description for the assessments card 3',
	},
	card4Heading: {
		id: 'fastshift.resources-page.card4.heading',
		defaultMessage: 'Assess Confluence cloud readiness',
		description: 'Heading for the assessments card 4',
	},
	card4Description: {
		id: 'fastshift.resources-page.card4.description',
		defaultMessage:
			'How to assess cloud readiness by collecting data from your Confluence instance.',
		description: 'Description for the assessments card 4',
	},
	card5Heading: {
		id: 'fastshift.resources-page.card5.heading',
		defaultMessage: 'Compare cloud migration methods',
		description: 'Heading for the Planning card 5',
	},
	card5Description: {
		id: 'fastshift.resources-page.card5.description',
		defaultMessage: 'Understand which migration method is best for your use case.',
		description: 'Description for the Planning card 5',
	},
	card6Heading: {
		id: 'fastshift.resources-page.card6.heading',
		defaultMessage: 'Milestone tracker template',
		description: 'Heading for the Planning card 6',
	},
	card6Description: {
		id: 'fastshift.resources-page.card6.description',
		defaultMessage: 'Use the document to track important milestones.',
		description: 'Description for the Planning card 6',
	},
	card7Heading: {
		id: 'fastshift.resources-page.card7.heading',
		defaultMessage: 'FastShift stages and data handling',
		description: 'Heading for the Planning card 7',
	},
	card7Description: {
		id: 'fastshift.resources-page.card7.description',
		defaultMessage: 'Understand migration stages and how we handle your data.',
		description: 'Description for the Planning card 7',
	},
	card8Heading: {
		id: 'fastshift.resources-page.card8.heading',
		defaultMessage: 'Roles and responsibilities',
		description: 'Heading for the Planning card 8',
	},
	card8Description: {
		id: 'fastshift.resources-page.card8.description',
		defaultMessage: 'Learn about roles and responsibilities in the FastShift migration process.',
		description: 'Description for the Planning card 8',
	},
	card9Heading: {
		id: 'fastshift.resources-page.card9.heading',
		defaultMessage: 'Issue tracker',
		description: 'Heading for the test run card 9',
	},
	card9Description: {
		id: 'fastshift.resources-page.card9.description',
		defaultMessage: 'Use this template to record and track issues that come up during test runs.',
		description: 'Description for the test run card 9',
	},
	card10Heading: {
		id: 'fastshift.resources-page.card10.heading',
		defaultMessage: 'Cloud Migration Runbook',
		description: 'Heading for the test run card 10',
	},
	card10Description: {
		id: 'fastshift.resources-page.card10.description',
		defaultMessage: 'View sample steps to help you prepare and execute a migration.',
		description: 'Description for the test run card 10',
	},
	card11Heading: {
		id: 'fastshift.resources-page.card11.heading',
		defaultMessage: 'Link fixing',
		description: 'Heading for the launch card 11',
	},
	card11Description: {
		id: 'fastshift.resources-page.card11.description',
		defaultMessage: 'Learn how to fix broken issue or page links after migration.',
		description: 'Description for the launch card 11',
	},
	card12Heading: {
		id: 'fastshift.resources-page.card12.heading',
		defaultMessage: 'Macro repair',
		description: 'Heading for the launch card 12',
	},
	card12Description: {
		id: 'fastshift.resources-page.card12.description',
		defaultMessage: 'Remap the Jira issue macro to correct app links after migration.',
		description: 'Description for the launch card 12',
	},
	linkText: {
		id: 'fastshift.resources-page.link-text',
		defaultMessage: 'Read',
		description: 'Text for the resource card link',
	},
	downloadText: {
		id: 'fastshift.resources-page.download-text',
		defaultMessage: 'Download',
		description: 'Download text for the resource card link',
	},
	usefulLinksHeading: {
		id: 'fastshift.resources-page.useful-links.heading',
		defaultMessage: 'Useful links',
		description: 'Heading for the useful links section',
	},
	partnerPortalLinkText: {
		id: 'fastshift.resources-page.useful-links.partner-portal.link-text',
		defaultMessage: 'Partner Portal',
		description: 'Link text for the partner portal link button',
	},
	billingConsoleLinkText: {
		id: 'fastshift.resources-page.useful-links.billing-console.link-text',
		defaultMessage: 'Billing Console',
		description: 'Link text for the billing console link button',
	},
	migrationSupportLinkText: {
		id: 'fastshift.resources-page.useful-links.migration-support.link-text',
		defaultMessage: 'Migration Support',
		description: 'Link text for the migration support link button',
	},
	tabPillAllText: {
		id: 'fastshift.resources-page.tabPill.all',
		defaultMessage: 'All',
		description: 'Text for the tab pill All',
	},
	tabPillAssessmentsText: {
		id: 'fastshift.resources-page.tabPill.assess',
		defaultMessage: 'Assess',
		description: 'Text for the tab pill Assessments',
	},
	tabPillPlanningText: {
		id: 'fastshift.resources-page.tabPill.plan',
		defaultMessage: 'Plan',
		description: 'Text for the tab pill Plan',
	},
	tabPillTestRunText: {
		id: 'fastshift.resources-page.tabPill.test',
		defaultMessage: 'Test',
		description: 'Text for the tab pill Test',
	},
	tabPillProductionRunText: {
		id: 'fastshift.resources-page.tabPill.production-run',
		defaultMessage: 'Production-run',
		description: 'Text for the tab pill Production-run',
	},
	tabPillLaunchText: {
		id: 'fastshift.resources-page.tabPill.launch',
		defaultMessage: 'Launch',
		description: 'Text for the tab pill Launch',
	},
	pageHeading: {
		id: 'fastshift.resources-page.page-heading',
		defaultMessage: 'Resources',
		description: 'Page heading for fastshift resources page',
	},
});
